import {openResourceModal} from '../../core/modalCommand';
import {
	AUDIT_LOGS_FILTER_MODAL_EVENT,
	AUDIT_LOGS_VIEW_MORE_MODAL_EVENT,
} from './events';

/**
 * Open the Audit Logs Filter modal.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAuditLogsFilterModal(command, envelope) {
	return openResourceModal(
		AUDIT_LOGS_FILTER_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open Log Details for a matching Audit Logs row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAuditLogsViewMoreModal(command, envelope) {
	return openResourceModal(
		AUDIT_LOGS_VIEW_MORE_MODAL_EVENT,
		command,
		envelope,
	);
}
